import React, { useEffect, useRef, useState } from 'react';
import allImgPaths from "assets/images";
import Sidebar from "../../components/common/Sidebar";
import Header from "../../components/common/Header";
import Footer from "../../components/Footer";
import FeteCard from 'components/dashboard/FeteCard';
import ReviewContentCard from 'components/reviewspace/ReviewContentCard';
import ReviewStatusButton from 'components/reviewspace/ReviewStatusButton';
import { addHistoryData, getAllBlocks, getFavoriteContent, getFavoriteEvents } from 'services/event';
import { t } from 'i18next';
import { cloneDeep } from 'lodash';
import FavoriteFeteCard from 'components/dashboard/FavoriteFeteCard';
import FavTrend from 'components/common/favorite/FavTrend';
import FavExplore from 'components/common/favorite/FavExplore';
import FavViewFilter from 'components/common/favorite/FavViewFilter';
import FavFilters from 'components/common/favorite/FavFilters';
import { differenceInDays } from 'date-fns';
import FavFavorites from 'components/common/favorite/FavFavorite';
import { useParams } from 'react-router-dom';
import { jsonToMarkdown } from 'utils/function';
import useAppState from 'context/useAppState';
import { getLLMAgentRAGUpdatePayload } from 'services/llm/payloads';
import { ExistingSettingMemberLoader } from 'components/loaders';

const themeFilterData = [
    { title: 'Fete Themes', value: 'Event Themes', selected: false },
    { title: 'Venue Styles', value: 'Venue Styles', selected: false },
    { title: 'Decor Drama', value: 'Decor Themes', selected: false },
    { title: 'Gift Ideas', value: 'Gift Ideas', selected: false }
]
const vendorFilterData = [
    { title: 'Venue', value: 'Venue', selected: false },
    { title: 'Gifts', value: 'Gifts', selected: false },
    { title: 'Decor', value: 'Decor', selected: false },
    { title: 'Entertainment', value: 'Entertainment', selected: false }
]

const attendeeFilterData = [
    // { title: 'Identify target audience', value: 'Identify target audience', selected: false },
    // { title: 'Create attendee list', value: 'Create attendee list', selected: false },
    // { title: 'Identify speakers', value: 'Identify speakers', selected: false },
    { title: 'Identify special guests', value: 'Identify special guests', selected: false }
]

const Favourite = () => {
    const { updateMessageContent, deleteMessage } = useAppState('chatMessages')
    const { updateRAGEntryOfFete, deleteRAGEntryOfFete } = useAppState('chatBox')
    const [isActiveColumn, setIsActiveColumn] = useState(0);
    const scrollContainerRef = useRef<HTMLDivElement>(null);
    const callFromBoard = true;
    const [isFeteSelected, setIsFeteSelected] = useState(true)
    const [eventsData, setEventsData] = useState<any>([])
    const [clonedEventsData, setClonedEventsData] = useState<any>([])
    const [allBlocks, setAllBlocks] = useState(['Fetes'])
    const [insightData, setInsightData] = useState<any>([])
    const [clonedInsightData, setClonedinsightData] = useState<any>([])
    const [eventTypes, setEventTypes] = useState<any>([]);
    const [loading, setLoading] = useState<boolean>(false);

    useEffect(() => {
        if (isActiveColumn === 0) {
            fetchEventData()
        }
        if (isActiveColumn > 0) {
            fetchInsightData()
        }
    }, [isActiveColumn])

    useEffect(() => {
        console.log('HERE')
    }, [eventTypes])

    const selectColumn = async (index: number) => {
        setIsActiveColumn(index)
        if (index == 0) {
            await fetchEventData()
        } else {
            console.log('Others')
        }
    }

    const fetchEventData = async () => {
        setEventsData([])
        setLoading(true);
        const currentTeam = JSON.parse(localStorage.getItem("selectedTeam") as string);
        const { data } = await getFavoriteEvents({ teamId: currentTeam?.currentTeamId })
        if (data?.length) {
            const updatedData = data.map((dt: any) => {
                if (dt?.start_date != dt?.end_date) {
                    const daysDifference = differenceInDays(dt?.end_date, dt?.start_date);
                    dt['duration'] = daysDifference
                }
                if (dt?.start_date == dt?.end_date) {
                    dt['duration'] = 1
                }
                if (!dt?.start_date) {
                    dt['duration'] = null
                }
                return dt;
            })

            setEventsData(updatedData || []);
            setClonedEventsData(updatedData || [])
        }

        // const eventTypes = (data || []).map((dt: any) => ({ title: dt?.type, selected: false })).filter((dt: any) => dt?.title);

        const eventTypes: any = Object.values(data.reduce((acc: any, { type }: any) => {
            if (!acc[type]) {
                acc[type] = { title: type, count: 0, selected: false };
            }
            acc[type].count += 1;
            return acc;
        }, {})).filter((dt: any) => dt?.title);


        setEventTypes(eventTypes)
        setLoading(false);
    }

    const fetchInsightData = async () => {
        setInsightData([])
        setLoading(true);
        const currentTeam = JSON.parse(localStorage.getItem("selectedTeam") as string);
        const { data } = await getFavoriteContent({ teamId: currentTeam?.currentTeamId })
        const filteredData = updateFavoriteData(data, isActiveColumn);

        console.log({ insightDataData: filteredData })
        setInsightData(filteredData)
        setClonedinsightData(filteredData)
        setLoading(false);
    }

    const updateFavoriteData = (data: any[], activeColumn: number) => {
        if (data?.length) {
            let filteredData = []
            if (isActiveColumn === 1) {
                filteredData = data.filter((dt: any) => themeFilterData.findIndex((tfd: any) => tfd.value.toLowerCase() == dt?.taskName?.toLowerCase()) > -1)
            }
            if (isActiveColumn === 2) {
                filteredData = data.filter((dt: any) => vendorFilterData.findIndex((tfd: any) => tfd.value.toLowerCase() == dt?.taskName?.toLowerCase()) > -1)
            }
            if (isActiveColumn === 3) {
                filteredData = data.filter((dt: any) => attendeeFilterData.findIndex((tfd: any) => tfd.value.toLowerCase() == dt?.taskName?.toLowerCase()) > -1)
            }

            filteredData.map((dt: any, dtIndex: number) => {
                // Add random messageId
                if (dt?.content?.length) {
                    dt.content.map((dc: any, dcIndex: number) => {
                        dc['newMessageId'] = dc.messageId + Date.now() + dtIndex + dcIndex;
                    })
                }
            })

            return filteredData
        }
        return []
    }

    const handleScroll = (direction: 'left' | 'right') => {
        if (scrollContainerRef.current) {
            scrollContainerRef.current.scrollBy({
                top: 0,
                left: direction === 'left' ? -200 : 200,
                behavior: 'smooth'
            });
        }
    };

    const columns = [
        { name: "Fetes" },
        { name: "Themes & Concepts" },
        { name: "Vendors" },
        { name: "Special attendees" }
    ];

    const removeFromList = (eventId: any) => {
        const clonedEvents = cloneDeep(eventsData);
        const index = clonedEvents.findIndex((ce: any) => JSON.stringify(ce._id) == JSON.stringify(eventId))
        if (index > -1) {
            clonedEvents.splice(index, 1);
            setEventsData(clonedEvents)
        }
    }

    const handleClick = (filterPayload: any) => {
        const { types, formats, durations } = filterPayload

        if (!types?.length && !formats?.length && !durations?.length) {
            setEventsData(clonedEventsData);
        } else {
            let updatedData = cloneDeep(clonedEventsData);
            if (types?.length) {
                updatedData = updatedData.filter((fd: any) => types.indexOf(fd.type) > -1);
            }
            if (formats?.length) {
                updatedData = updatedData.filter((fd: any) => formats.indexOf(fd.format) > -1);
            }
            if (durations?.length) {
                if (durations.includes('Single Day') && !durations.includes('Multi-Day')) {
                    updatedData = updatedData.filter((fd: any) => fd?.duration == 1);
                }
                if (durations.includes('Multi-Day') && !durations.includes('Single Day')) {
                    updatedData = updatedData.filter((fd: any) => fd?.duration > 1);
                }
                if (durations.includes('Single Day') && durations.includes('Multi-Day')) {
                    updatedData = updatedData.filter((fd: any) => fd?.duration >= 1);
                }
            }

            setEventsData(updatedData)
        }
    }

    const setItemIsFavorite = async (ids: any, title: string, value: boolean) => {
        const { messageId, taskId } = ids
        if (taskId) {
            const taskData = insightData.find((idt: any) => JSON.stringify(idt.taskId) == JSON.stringify(taskId))
            const taskDataIndex = insightData.findIndex((idt: any) => JSON.stringify(idt.taskId) == JSON.stringify(taskId))

            console.log({ taskData, taskDataIndex })

            if (taskData) {
                const taskContent = (taskData?.content || []).filter((tc: any) => JSON.stringify(tc.messageId) == JSON.stringify(messageId));
                taskContent.map((td: any) => {
                    if (td.title == title) td['is_favorite'] = value
                });

                const favoriteItemMessageId = taskContent.find((td: any) => td.title == title).newMessageId
                // await callAPIs(taskData, taskContent, taskId, messageId, taskDataIndex, false, favoriteItemMessageId)

                // Call History API
                const changedContent = taskContent.find((tc: any) => tc.title == title);
                const addHistoryPayload = {
                    ragId: changedContent.ragId,
                    taskTitle: title,
                    taskType: 'items',
                    actionType: 'isFavorite',
                    isFavorite: changedContent.is_favorite
                }
                console.log({ addHistoryPayload })
                console.log({ taskData, taskContent, taskId, messageId, taskDataIndex, bool: false, favoriteItemMessageId })

                await addHistoryData(addHistoryPayload)

                await callAPIs(taskData, taskContent, taskId, messageId, taskDataIndex, false, favoriteItemMessageId)
            }
        }
    }

    const callAPIs = async (taskData: any, taskContent: any, taskId: any, messageId: any, taskDataIndex: any, isRichTextContent: boolean, newMessageId: any) => {
        if (taskContent?.length) {
            let contentPayload: any = {}
            let items = []
            let ragItems = []

            if (taskContent[0]?.heading) {
                items = taskContent.map(({ title, description, selected, is_favorite, is_pinned }: any) => ({
                    title,
                    description,
                    selected,
                    is_pinned,
                    is_favorite: is_favorite !== undefined ? is_favorite : false
                })) || []
                contentPayload = { ...contentPayload, heading: taskContent[0].heading, items }

                ragItems = cloneDeep(contentPayload.items?.filter((ci: any) => ci?.selected))
                ragItems.map((fc: any) => {
                    delete fc['selected']
                })
            }

            if (taskContent[0]?.renderImages) {
                items = taskContent.map(({ title, description, selected, tags, is_favorite, is_pinned }: any) => ({
                    title,
                    imageDescription: description,
                    selected,
                    is_pinned,
                    tags, selectedTags: tags,
                    is_favorite: is_favorite !== undefined ? is_favorite : false
                })) || []
                contentPayload = { ...contentPayload, renderImages: true, items }

                ragItems = cloneDeep(contentPayload.items?.filter((ci: any) => ci?.selected))
                ragItems.map((fc: any) => {
                    fc['tags'] = (fc['selectedTags'] || []).filter((st: any) => st)
                    delete fc['selectedTags']
                    if (fc?.imageDescription) delete fc.imageDescription
                    delete fc['selected']
                    if (fc?.description) delete fc.description;
                    if (fc?.imageUrl) delete fc.imageUrl
                    if (fc?.type == 'crawled') {
                        delete fc.type
                        delete fc.tags;
                    }
                })
            }

            const currentTeam = JSON.parse(localStorage.getItem('selectedTeam') as string)
            const messagePayload = {
                content: JSON.stringify(contentPayload),
                teamId: currentTeam?.currentTeamId,
                eventId: taskData?.eventId,
                is_draft: false,
                taskId: taskId,
                cardId: taskData?.cardId,
                blockId: taskData?.blockId
            }

            // Update in DocDB
            // setShowDeleteModal(false)  // Close delete modal
            try {
                if (isRichTextContent) {
                    // await deleteMessage(messageId)
                } else {
                    await updateMessageContent(messageId, messagePayload)
                }
                reRenderInsightData(taskContent, taskDataIndex, newMessageId)
                await handleRAGCall({ items: ragItems }, taskId, messageId, taskData);
            } catch (error) {
                console.log({ error })
                // handleApiCases(false)
            }

        }
    }

    const reRenderInsightData = (taskContent: any[], taskDataIndex: any, newMessageId: any) => {
        const updatedContentData = taskContent.find((tc: any) => JSON.stringify(tc.newMessageId) == JSON.stringify(newMessageId))
        console.log({ taskContent, taskDataIndex, newMessageId, updatedContentData })

        let updatedInsightData = insightData.map((item: any, index: number) => {
            if (index === taskDataIndex) {
                let mainContent: any[] = item.content || [];

                if (!taskContent?.length) {
                    const removalIndex = mainContent.findIndex((mc: any) => JSON.stringify(mc.newMessageId) == JSON.stringify(newMessageId))
                    if (removalIndex > -1) {
                        mainContent.splice(removalIndex, 1)
                    }
                } else {
                    const removalIndex = mainContent.findIndex((mc: any) => JSON.stringify(mc.newMessageId) == JSON.stringify(newMessageId))
                    console.log({ removalIndex })
                    if (removalIndex > -1) {
                        mainContent.splice(removalIndex, 1)
                    }

                }

                return { ...item, content: mainContent }
            }

            return item
        })

        // Filter out card data which has no tasks left
        updatedInsightData = updatedInsightData.filter((item: any, index: any) => item?.content.length > 0);

        setInsightData(updatedInsightData)
    }

    const handleRAGCall = async (content: any, taskId: any, messageId: any, taskData: any) => {
        const userData = JSON.parse(localStorage.getItem('userData') as string)
        const userEmail = localStorage.getItem('userEmail')
        const currentTeam = JSON.parse(localStorage.getItem('selectedTeam') as string)

        let ragPayload: any = {
            text_content: jsonToMarkdown(content),
            text_prefix: `The current selected or chosen items for ${taskData.taskName} are: `
        }

        const ragMetaData = {
            userId: userData?.id,
            userEmail: userEmail,
            teamId: currentTeam?.currentTeamId,
            eventId: taskData?.eventId,
            is_draft: false,
            taskId: taskId,
            updatedAt: new Date().toISOString(),
            cardId: taskData?.cardId
        }

        ragPayload = { ...ragPayload, document_path: messageId, additional_metadata: ragMetaData }

        try {
            await updateRAGEntryOfFete(getLLMAgentRAGUpdatePayload(ragPayload))
        } catch (err) {
            console.log({ err })
        }
    }

    const handleViewClick = (args: any) => {
        const filteredData = updateFavoriteData(clonedInsightData, args.activeColumn)
        if (args?.selected?.length) {
            const updatedData = cloneDeep(filteredData).filter((fd: any) => args.selected.includes(fd.taskName))
            setInsightData(updatedData)
        } else {
            const updatedData = cloneDeep(filteredData)
            setInsightData(updatedData)
        }
    }

    const [formValue, getFormValue] = useState();
    const [isFocused, setIsFocused] = useState<boolean>(false);
    const handleSearchValue = (event: any) => {
        getFormValue(event.target.value);
        console.log(formValue);
    }

    const handleFocus = () => {
        setIsFocused(true);
        console.log('test');
    };

    const handleBlur = () => {
        setIsFocused(false);
    };


    return (
        <div className='flex'>
            <Sidebar />

            <div className="w-[calc(100%_-_72px)] ml-auto">
                <Header />

                <div className="pt-6 px-8 h-[calc(100vh_-_125px)] overflow-y-scroll scrollbar-adjust">
                    {/* Heading */}
                    <div className="flex justify-between items-center w-full mb-14">
                        <div className="">
                            <h2 className='text-[#101828] text-2xl font-interSemiBold '>Favorites</h2>
                            <p className='text-base text-[#475467]'>View all your favorites in one place</p>
                        </div>
                        <div className="">
                            <div className={`border hover:border-[#1e0af5] rounded-lg w-80 py-2 px-3.5 flex items-center gap-x-2 ${isFocused ? "border-[#1e0af5]" : "border-[#D0D5DD]"}`}>
                                <img src={allImgPaths.searchIcon} alt="search" />
                                <input
                                    className="w-full"
                                    placeholder="Search"
                                    type="text"
                                    onChange={handleSearchValue}
                                    value={formValue}
                                    onFocus={handleFocus}
                                    onBlur={handleBlur}
                                />
                            </div>
                        </div>
                    </div>

                    <div className="bg-[#FFF] border-b border-[#EAECF0]">
                        <div className="flex items-center justify-center w-full px-6">
                            <img className="cursor-pointer on-hover-bg-grey rounded" src={allImgPaths.leftArrow} alt="" onClick={() => handleScroll('left')} />
                            <div id="scrollBoardContainer" ref={scrollContainerRef} className="flex items-center justify-around no-scrollbar overflow-x-auto h-[48px] w-[calc(100vw_-_225px)]">
                                {columns?.length > 0 && columns.map((column: any, cIndex: any) => (
                                    <span
                                        key={cIndex}
                                        onClick={() => { selectColumn(cIndex) }}
                                        className={`${isActiveColumn === cIndex ? "text-[#1e0af5] planning-board-border-bottom after:bg-[#1e0af5]" : "text-[#667085]"} font-interMedium text-base pointer-cursor relative mx-10 flex-shrink-0 hover:text-[#1e0af5]`}
                                    >
                                        {column.name}
                                    </span>
                                ))}
                            </div>
                            <img className="cursor-pointer on-hover-bg-grey rounded" src={allImgPaths.rightArrow} onClick={() => handleScroll('right')} alt="" />
                        </div>
                    </div>

                    <div className="h-2.5 bg-white w-full"></div>

                    {
                        loading && (eventsData?.length == 0 || insightData?.length == 0) && <ExistingSettingMemberLoader />
                    }

                    {
                        !loading && isActiveColumn === 0 &&
                        // {loading && (filterData.members.length == 0 && filterData.members.blocks == 0 && filterData.members.types == 0) && <ExistingSettingMemberLoader />}
                        <div className={`px-6 py-6 w-full flex gap-x-24 items-start`}>
                            {/* cards */}
                            {
                                eventTypes && eventTypes.length > 0 &&
                                <>
                                    <FavFilters eventTypes={eventTypes} handleClick={handleClick} />
                                </>
                            }

                            {eventsData && eventsData.length > 0 &&
                                <div className="w-full flex flex-wrap gap-y-4 gap-x-4 items-start">
                                    {
                                        eventsData && eventsData.length > 0 && eventsData.map((event: any, index: number) => (
                                            <FavoriteFeteCard key={index} event={event} removalIndex={removeFromList} />
                                        ))
                                    }
                                </div>
                            }

                            {
                                eventsData.length == 0 &&
                                (
                                    <div className="w-full h-[calc(100vh_-_400px)] flex items-center justify-center flex-col">
                                        <img className='mx-auto mb-3' src={allImgPaths.historyFavoriteState} alt="" />
                                        <p className='font-interSemiBold text-base text-[#344054] pb-1 text-center'>No favorites found</p>
                                        <p className='text-base font-normal text-[#344054] mb-4 text-center max-w-96 mx-auto leading-relaxed'>Heart the fetes, themes, templates you like and we will collect them all here for a quick lookup.</p>
                                    </div>
                                )
                            }

                        </div>
                    }

                    {
                        !loading && isActiveColumn > 0 &&
                        <>
                            <div className="px-6 py-6 w-full flex gap-x-24 items-start">
                                {/* Left - Filter */}

                                {
                                    isActiveColumn == 1 &&
                                    <FavViewFilter data={themeFilterData} handleViewClick={handleViewClick} activeColumn={isActiveColumn} />
                                }
                                {
                                    isActiveColumn == 2 &&
                                    <FavViewFilter data={vendorFilterData} handleViewClick={handleViewClick} activeColumn={isActiveColumn} />
                                }
                                {
                                    isActiveColumn == 3 &&
                                    // <FavViewFilter data={themeFilterData} />
                                    <div></div>
                                }

                                {/* Center - Cards */}
                                {
                                    insightData?.length > 0 &&
                                    <div className="w-full flex flex-wrap gap-y-4 gap-x-4 items-start">
                                        {
                                            insightData?.length > 0 && insightData.map((fc: any, index: number) => (
                                                <React.Fragment key={index}>
                                                    {
                                                        fc?.content?.length > 0 && fc.content.map((content: any, contentIndex: number) => (
                                                            <React.Fragment key={contentIndex}>
                                                                <FavFavorites favoritesData={content} taskId={fc.taskId} setItemIsFavorite={setItemIsFavorite} />
                                                            </React.Fragment>
                                                        ))
                                                    }
                                                </React.Fragment>
                                            ))
                                        }
                                    </div>
                                }
                                {
                                    insightData.length == 0 &&
                                    (
                                        <div className="w-full h-[calc(100vh_-_400px)] flex items-center justify-center flex-col">
                                            <img className='mx-auto mb-3' src={allImgPaths.historyFavoriteState} alt="" />
                                            <p className='font-interSemiBold text-base text-[#344054] pb-1 text-center'>No favorites found</p>
                                            <p className='text-base font-normal text-[#344054] mb-4 text-center max-w-96 mx-auto leading-relaxed'>Heart the fetes, themes, templates you like and we will collect them all here for a quick lookup.</p>
                                        </div>
                                    )
                                }

                            </div>
                        </>
                    }
                </div>
                <Footer />
            </div>
        </div>

    )
}

export default Favourite